// CheckoutForm.js
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { str } from "ajv";
import { useState, useContext } from "react";
import { BackendContext } from '../Context/BackendContext';

const formatInt = n => Number(n ?? 0).toLocaleString('en-US');

export default function CheckoutForm({ pack, onClose, onReady, onSuccess }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const { updateUserTokens } = useContext(BackendContext);

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
    });

    if (error) {
      setMessage(error.message);
      setLoading(false);
      return;
    }

    if (paymentIntent?.status === 'succeeded') {
      // Handle successful payment here
      setMessage("Payment successful! Crediting Pixel Drops...");
      // Optionally, you can redirect or update UI
      setTimeout(async () => {
        await updateUserTokens(); // implement if not present
        setLoading(false);
        onSuccess?.(pack.tokens + pack.extraTokens);
        onClose?.(); // close modal
      }, 5000);
    } else {
      setMessage(`Status: ${paymentIntent?.status ?? 'unknown'}`);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <PaymentElement  options={{
        layout: 'tabs',
        theme: 'night',
        }}
        onReady={() => {
          onReady?.();   // notify StorePage that Elements are mounted
        }}
        />
      {/* Total Amount Label + Token Summary Container */}
      <div className="w-full max-w-3xl mx-auto px-2">
        {/* Label */}
        <div className="text-xs text-gray-400 tracking-wider uppercase mb-1">
          Total Amount
        </div>

        {/* Token Summary */}
        <div className="flex items-center justify-between bg-[#12172A] rounded-lg px-6 py-4 shadow-md text-white">
          {/* Left: Total tokens */}
          <div className="flex items-center gap-2 font-bold text-lg">
            <svg className="w-5 h-5 text-indigo-400" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2L2 12l10 10 10-10L12 2z" />
            </svg>
            {formatInt(pack.tokens + pack.extraTokens)}
          </div>

          {/* Right: Base + Bonus + Buy */}
          <div className="flex items-center gap-6">
            {/* Base + Bonus tokens */}
            <div className="flex items-center gap-1 text-sm text-gray-300">
              <svg className="w-4 h-4 text-indigo-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L2 12l10 10 10-10L12 2z" />
              </svg>
              {formatInt(pack.tokens)} + <span className="text-indigo-400 font-semibold">{formatInt(pack.extraTokens)} BONUS</span>
            </div>

            
          </div>
        </div>
      </div>
      {/* Buy Button */}
      <button
        disabled={!stripe || loading}
        className="bg-indigo-500 text-white w-full max-w-3xl mb-1 mx-auto px-2 py-4 rounded-xl disabled:opacity-50"
      >
        {loading ? "Processing..." : `Pay ${pack.price}`}
      </button>
      {message && <div className="text-white-500 text-sm">{message}</div>}
    </form>
  );
}
